import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import StudyDesk from '../components/StudyObjects';

export default function Home() {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    fetch('/api/articles').then(r => r.json()).then(d => setArticles(d.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <div className="fade-in">
      <section className="hero">
        <div className="hero-left">
          <p className="hero-kicker">✦ zahra's learning</p>
          <h1>
            Hello,<br />
            je suis<br />
            <span className="italic hero-name">fatima-zahra</span>.
          </h1>
          <p className="hero-tagline">
            J'écris, je bidouille, j'apprends, je documente. Bienvenue dans mon
            petit coin d'internet — où les idées prennent forme entre deux cafés.
          </p>
          <div className="hero-meta">
            <Link to="/articles" className="tag">✎ articles</Link>
            <Link to="/cards" className="tag">✦ cards</Link>
            <Link to="/qcm" className="tag">◆ qcm</Link>
            <Link to="/notes" className="tag">☕ pensées</Link>
          </div>
        </div>
        <div className="hero-right">
          <StudyDesk />
        </div>
      </section>

      <div className="marquee">
        <div className="marquee-track">
          <span>écrire</span><span className="dot">✦</span>
          <span>coder</span><span className="dot">✦</span>
          <span>apprendre</span><span className="dot">✦</span>
          <span>explorer</span><span className="dot">✦</span>
          <span>partager</span><span className="dot">✦</span>
          <span>écrire</span><span className="dot">✦</span>
          <span>coder</span><span className="dot">✦</span>
          <span>apprendre</span><span className="dot">✦</span>
          <span>explorer</span><span className="dot">✦</span>
          <span>partager</span><span className="dot">✦</span>
        </div>
      </div>

      <section className="section">
        <div className="section-head">
          <h2>derniers articles</h2>
          <Link to="/articles" className="btn secondary">voir tous →</Link>
        </div>
        {articles.length === 0 ? (
          <div className="empty-state">rien encore ici. bientôt des mots par ici ✎</div>
        ) : (
          <div className="articles-grid">
            {articles.map(a => (
              <Link key={a.id} to={`/articles/${a.slug}`} className="card">
                {a.cover_image
                  ? <img src={a.cover_image} alt={a.title} className="card-image" />
                  : <div className="card-placeholder">✦</div>}
                <div className="card-date">{new Date(a.created_at).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
                <h3>{a.title}</h3>
                <p className="card-excerpt">{a.excerpt}</p>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
